import Layout from 'components/Layout'
import AnimatePresence from 'components/ui/animate-presence'
import React from 'react'
import ContactForm from '../components/ContactForm'

const ContactUs = () => {
  return (
    <Layout>
      <AnimatePresence name="contact-us">
        <div className="text-text-primary flex flex-col items-center lg:flex-row p-4 sm:p-6 mx-auto lg:rounded-2xl bg-background h-full lg:h-[calc(100vh-100px)]">
          <div className="hidden lg:flex flex-shrink-0 lg:h-full items-center" style={{ width: '500px' }}>
            <img
              alt="contact-page"
              className="object-cover rounded-xl mb-6 lg:mb-0 w-full h-auto"
              src="/contact.svg"
            />
          </div>
          <div className="w-full py-6 lg:py-0 px-4 sm:px-8 lg:px-[72px]">
            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-semibold mb-6">
              Contact Us
            </h1>
            <ContactForm />
          </div>
        </div>
      </AnimatePresence>
    </Layout>
  )
}

export default ContactUs
